// Whether a job asks that applicants be U.S. citizens or permanent residents.
//
// Requiring U.S. citizenship or permanent residency of applicants is lawful only when the law or a
// government contract demands it, so the company certifies that each time it publishes such a job.
// The API server and the job dashboard both decide "does this job need that certification" with
// this one check.
//
// Written as plain CommonJS so the API server, which runs its files under plain node, can require
// this same file the browser bundle imports.

const CITIZENSHIP_REQUIREMENTS = ['U.S. Citizenship required', 'Lawful Permanent Resident (Green Card holder)'];

// `workAuthReqJob` is stored either as a list of the chosen options or as a single one.
function requiresCitizenship(workAuthReqJob) {
  const chosen = Array.isArray(workAuthReqJob) ? workAuthReqJob : [workAuthReqJob];
  return chosen.some(value => CITIZENSHIP_REQUIREMENTS.includes(value));
}

module.exports = { CITIZENSHIP_REQUIREMENTS, requiresCitizenship };
